import { Link, useNavigate } from "react-router-dom";
import "../userAuth.css";
import { IAuthType } from "../../../apiservice/authService.type";
import { useAppSelector } from "../../../Redux/reduxCustomHook";
import { RootState } from "../../../Redux/store";

const UserSignUpStepComplete = () => {
  const authData: IAuthType = useAppSelector(
    (state: RootState) => state?.AuthData
  );

  return (
    <>
      <div className="w-full min-h-screen flex justify-center bg-white dark:bg-stone-900">
        <div className="p-8 rounded-lg w-full max-w-lg self-center bg-white dark:bg-stone-800 shadow-lg"> {/* Added self-center and card styles */}
          <div className="mb-12 flex items-center flex-col">
            <p className="text-black dark:text-stone-100 text-2xl font-semibold">
              <u> Completed</u></p>
          </div>

          <div className="w-full flex flex-col items-center p-4 pt-12 pb-12">
            <img
              src={`${process.env.PUBLIC_URL + "/images/auth/signupcomplete.svg"
                }`}
              alt="Logo"
              className="w-60 h-auto"
            />
            <br />

            <p className="text-center font-semibold text-lg text-slate-900 dark:text-stone-200">
              You're all set, {authData?.data?.credentials?.firstName}! Let's
              start growing your finances today!
            </p>
          </div>

          {/* Sign Up Button */}
          <div className="mb-8">
            <Link to={"/users/home"}>
              <button className="w-full h-16 fontAlbertSansRegular bg-blue-800 hover:bg-blue-700 dark:hover:bg-blue-600 text-white rounded-lg text-lg">
                {" "}
                Continue{" "}
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserSignUpStepComplete;
